import { Controller } from "@hotwired/stimulus"
//import Chart from "chart.js/auto"

export default class extends Controller {
  connect() {
    this.createChart()
  }

  createChart() {
    const data = [
      { year: 2010, count: 10 },
      { year: 2011, count: 20 },
      { year: 2012, count: 15 },
      { year: 2013, count: 25 },
      { year: 2014, count: 22 },
      { year: 2015, count: 30 },
      { year: 2016, count: 28 },
    ];

    const e = document.getElementById('simple-chart')
    const te = this.element

    window.e = e
    window.te = te

    console.log(`Type of getElementById: ${typeof e}`);
    console.log(`Type of this.element: ${typeof te}`);

    const context = te.getContext("2d");

    // Detect if we're in a PDF/print context
    const isPrintContext = window.matchMedia && window.matchMedia('print').matches

    const chart = new Chart(
      context,
      {
        type: 'bar',
        options: {
          animation: false, // Disable animations for PDF rendering
          responsive: true, //!isPrintContext, // Disable responsive in print context
          maintainAspectRatio: false,
          devicePixelRatio: 2.0,
        },
        data: {
          labels: data.map(row => row.year),
          datasets: [
            {
              label: 'Acquisitions by year',
              data: data.map(row => row.count)
            }
          ]
        }
      }
    );
  }
}
